import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./Contributors.css";

export default function Contributors({ logos }: any) {
  return (
    <div className="competitive-sites-main-div">
      <ul className="dev-icons">
        {logos.map(
          (logo: {
            siteName: string;
            profileLink: string | undefined;
            iconifyClassname: any;
            style: React.CSSProperties | undefined;
          }) => {
            return (
              <li className="competitive-sites-inline">
                <a
                  href={logo.profileLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    alt="contributor"
                    src={logo.profileLink}
                    className="iconify"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      borderRadius: "50%",
                      border: "3px #fff solid",
                      padding: 2,
                    }}
                  ></img>
                </a>
              </li>
            );
          }
        )}
      </ul>
    </div>
  );
}
